const state = {
    prelandings: []
}

export default state
